function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.094-11.25H-6.094A1.407,1.407,0,0,0-7.5-9.844v8.437A1.407,1.407,0,0,0-6.094,0H6.094A1.407,1.407,0,0,0,7.5-1.406V-9.844A1.407,1.407,0,0,0,6.094-11.25Zm-12.187.937H6.094a.47.47,0,0,1,.469.469v1.213C5.921-8.089,5-7.342,2.15-5.077,1.655-4.685.68-3.738,0-3.75c-.68.012-1.658-.935-2.15-1.327C-5-7.342-5.921-8.089-6.563-8.631V-9.844A.47.47,0,0,1-6.094-10.312ZM6.094-.937H-6.094a.47.47,0,0,1-.469-.469V-7.412c.668.548,1.723,1.395,3.829,3.067.6.48,1.661,1.538,2.733,1.532s2.118-1.04,2.733-1.532C4.84-6.018,5.895-6.864,6.562-7.412v6.006A.47.47,0,0,1,6.094-.937Z",
  transform: "translate(7.5 11.25)",
  opacity: 0.871
});

var SvgIconSide15 = function SvgIconSide15(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11.25,
    viewBox: "0 0 15 11.25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSide15, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-side-15.8fb2f924.svg";
export { ForwardRef as ReactComponent };